import Button from '../../common/Button';

const ActionButtons = ({ onCancel, onConfirm, confirmText = "Purchase Subscription", plan, disabled, step }) => (
    <div className='df aifs jcc mt2rem w100 px2rem'>
        <Button
            onClick={onCancel}
            btnType="warningOutlined"
            customClassName='mr0-5rem w100'
            text="Cancel"
            style={{ width: '280px' }}
        />
        <div className='df fdc aic jcc w100' style={{ width: '280px' }}>
            <Button onClick={onConfirm} disabled={disabled} btnType="warning" customClassName='w100' text={confirmText} />
            {
                ((step && !step.toLowerCase().includes('free')) && !plan.toLowerCase().includes('free') && !plan.toLowerCase().includes('discount')) ?
                    <p className='c15 op70 fs12px'>A Stripe payment window will open</p> : null
            }
        </div>
    </div>
);

export default ActionButtons; 